import React, { useEffect } from "react";
import { useGLTF } from "@react-three/drei";
import { useColorStore } from "./stores/ColorStore";
import { useModelDataStore } from "./stores/ModelDataStore";

export function TBC169(props) {
    const { nodes, materials } = useGLTF("/TBC169-50.glb");

    const currentBodyColor = useColorStore((state) => state.body)
    const currentCapColor = useColorStore((state) => state.cap)

    let updateUV = useModelDataStore((state) => state.updateUVData)
    useEffect(() => {
        if (props.isBeingEdited)
            updateUV(nodes["TBC169-50_Body"].geometry.attributes.uv.array)
    }, [props.isBeingEdited])

    return (
        <group 
            position={props.position}    
            rotation={[0, -3.62, 0]}         
            dispose={null}
        >
            <mesh geometry={nodes["TBC169-50_Cap"].geometry}>
                <meshStandardMaterial roughness={0.22} color={props.isBeingEdited ? currentCapColor : "white"} />
            </mesh>
            <mesh geometry={nodes["TBC169-50_Body"].geometry} material={materials["TBC169-33_Body"]}>
                <meshPhysicalMaterial
                    color={props.isBeingEdited ? currentBodyColor : "white"}
                    {...props.materialSettings}
                    map={materials["TBC169-33_Body"].map}
                />
                {/* <meshStandardMaterial
                    transparent={true}
                    roughness={0.15}
                    color={props.isBeingEdited ? currentBodyColor : "white"}
                    // alphaTest={0}
                /> */}
            </mesh>
        </group>
    );
}

useGLTF.preload("/TBC169-50.glb");

